import { Component } from "react";
import { clone, guid } from "../../../utils";
import FormSelectField from "./FormSelectField";

class FormRatingScalesField extends Component {
    ratingChange(rowResponseAnswer, selectedColumnId) {
        let response = clone(this.props.question);
        let responseAnswers = response.response_answers.filter((ra) => ra.answer_id === rowResponseAnswer.id);
        let currentResponseAnswer = responseAnswers.find((ra) => ra.column_id === selectedColumnId);
        responseAnswers.forEach((ra) => (ra.deleted = true));

        if (!currentResponseAnswer) {
            currentResponseAnswer = {
                column_id: selectedColumnId,
                answer: "True",
                answer_id: rowResponseAnswer.id,
                comment: "",
                comment_field: "",
                id: null,
                guid: guid(),
                response_id: response.id,
                value_choice: "",
                deleted: false,
            };

            response.response_answers.push(currentResponseAnswer);
        } else {
            currentResponseAnswer.deleted = false;
        }

        this.props.responseValueChange(response);
    }

    render() {
        let ratingScalesElements = this.props.answers
            .sort((a1, a2) => {
                if (a1.sequence < a2.sequence) return -1;
                else if (a1.sequence > a2.sequence) return 1;
                else return 0;
            })
            .map((a) => {
                return (
                    <div key={a.id} className="row">
                        <FormSelectField
                            responseValueChange={this.ratingChange.bind(this, a)}
                            question={this.props.question.response_answers.find(
                                (ra) => ra.answer_id === a.id && !ra.deleted
                            )}
                            metaQuestion={{ question: a.answer, type: "multiple_choice_only_one_ans" }}
                            answers={this.props.metaQuestion.column_heading_ids}
                            inputProperties={this.props.inputProperties}
                            save={this.props.save}
                            ratingScale
                        />
                    </div>
                );
            });

        return <div>{ratingScalesElements}</div>;
    }
}

export default FormRatingScalesField;
